import { useState, useEffect } from 'react'

import { CHANGE_DEALER_CREDIT } from '../../../../utils/sockets'
import Button from '../../../../components/Button'
import Dialog from '../../../../components/Dialog'
import InputGroup from '../../../../components/InputGroup'

const ViewDealerCreditChangeBalanceModal = (props) => {
  const { isOpen, setIsOpen, socket, balance, onSuccess } = props

  const [newBalance, setNewBalance] = useState(balance)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setSuccess(null)
      setError(null)
    }
  }, [isOpen])

  const handleChange = (e) => {
    // Remove everything except 0-9
    const input = e.target.value.replace(/[^0-9.]/g, '')
    setNewBalance(input)
  }

  const handleSubmit = () => {
    setIsLoading(true)

    socket.emit(
      CHANGE_DEALER_CREDIT,
      { balance: Math.round(parseFloat(newBalance * 100)) / 100 },
      (err, dealerCredit) => {
        setIsLoading(false)

        if (dealerCredit) {
          setSuccess(true)
          onSuccess(dealerCredit)
          return
        }

        if (err) {
          setError(err)
          return
        }
      },
    )
  }

  if (error) {
    return (
      <Dialog
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="An error occurred"
        buttonProps={null}
      >
        <p className="text-gray-600 text-sm mt-2">
          There was an error saving the new balance.
        </p>
        <Button className="mt-4" onClick={setIsOpen}>
          Finish and close
        </Button>
      </Dialog>
    )
  }

  if (success) {
    return (
      <Dialog
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Dealer balance changed"
        buttonProps={null}
      >
        <p className="text-gray-600 text-sm mt-2">
          We have successfully changed the dealer credit balance to{' '}
          {newBalance === '1'
            ? `${newBalance} credit`
            : `${newBalance} credits`}
          .
        </p>
        <Button className="mt-4" onClick={setIsOpen}>
          Finish and close
        </Button>
      </Dialog>
    )
  }

  return (
    <Dialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Change credit balance"
      buttonProps={{
        disabled: isLoading || !newBalance,
        onClick: handleSubmit,
        children: isLoading ? 'Saving...' : 'Save balance',
        color: 'primary',
      }}
    >
      <div className="mt-2">
        <InputGroup
          required
          label="New balance"
          id="creditBalance"
          disabled={isLoading}
          onChange={handleChange}
          value={newBalance}
        />
      </div>
    </Dialog>
  )
}

export default ViewDealerCreditChangeBalanceModal
